import React, { useState, useEffect, createContext } from 'react';
import { DndProvider } from 'react-dnd';
import { compose } from 'redux';
import Backend from 'react-dnd-html5-backend';
import classNames from 'classnames';
import ScrollArea from 'react-scrollbars-custom';

import HotKey from './common/HotKey';
import Header from './editor/Header';
import LeftSidebar from './editor/sidebars/LeftSidebar';
import RightSidebar from './editor/sidebars/RightSidebar';
import Theme from './editor/Theme';
import Template from './editor/Template';
import Preview from './editor/Preview';
import Mobile from './editor/preview/Mobile';
import Favorite from './editor/Favorite';
import HtmlEditor from './editor/HtmlEditor';
import ImportRss from 'shared/components/ImportRss';
import ImportUrl from 'shared/components/ImportUrl';
import { customTranslate } from 'shared/lib/tinyTranslator';

import connectProps from 'fantastic/lib/connectProps';
import DraggingContext from 'fantastic/lib/DraggingContext';
import utils from 'fantastic/lib/utils';

const Editor = ({ preview, settings, html, dragging, theme }) => {
  const [showHtml, setShowHtml] = useState(false);

  const divClasses = classNames('fantastic-editor', {
    'fantastic-editor--preview': preview,
    'fantastic-editor--html': showHtml,
    'fantastic-editor--html-left': showHtml && html.dir === 'left',
  });

  const adminMode = settings && settings.admin_mode;
  const rssUrl = settings && settings.rss_url;
  const htmlUrl = settings && settings.html_url;

  useEffect(() => {
    customTranslate();
  }, []);
  useEffect(() => {
    if (!!!html.id) {
      setShowHtml(false);
    }
    const timer = setTimeout(
      () => {
        if (!!html.id) {
          setShowHtml(true);
        }
      },
      !!html.id ? 0 : 200,
    );
    return () => clearTimeout(timer);
  }, [html.id]);

  const [readyTheme, setReadyTheme] = useState(false);
  const viewClasses = classNames('fantastic-view', {
    'fantastic-view--ready': readyTheme,
  });

  const handleThemeReady = (ready) => {
    setReadyTheme(ready);
  };

  const bodyStyle = () => {
    if (showHtml && html.dir === 'left') {
      return {
        marginLeft: `${html.size}%`,
        width: `${100 - html.size}%`,
      };
    }
    if (showHtml && html.dir === 'bottom') {
      return {
        overscrollBehaviorY: 'contain',
        overflowY: 'auto',
        height: `calc(calc(calc(calc(100vh - 131px) * ${100 - html.size}) / 100) + 31px)`,
      };
    }
  };

  const globaBackgroundStyles = () => {
    if (!showHtml) return;

    return {
      backgroundColor: theme.style_attributes['base-bg'],
      backgroundImage: utils.url(theme.style_attributes['base-bg-image']),
      backgroundRepeat: theme.style_attributes['base-bg-repeat'],
      backgroundPosition: theme.style_attributes['base-bg-position'],
    };
  };

  return (
    <div className={divClasses}>
      <HotKey />
      <Header preview={preview} />
      <DndProvider backend={Backend}>
        <LeftSidebar settings={settings} />
        <RightSidebar settings={settings} />
        <div className={viewClasses} style={globaBackgroundStyles()}>
          {preview ? (
            <div className="fantastic-view__frame">
              <div className="fantastic-view__bar">
                <span />
                <span />
                <span />
              </div>
              <div className="fantastic-view__screen">
                <ScrollArea>
                  <Preview />
                </ScrollArea>
              </div>
            </div>
          ) : (
            <>
              <DraggingContext.Provider value={{ dragging }}>
                <Template style={bodyStyle()} />
              </DraggingContext.Provider>
              <HtmlEditor {...html} adminMode={adminMode} />
            </>
          )}
        </div>
        <Mobile on={preview} />
      </DndProvider>
      <Theme onReady={handleThemeReady} />
      <Favorite />
      {rssUrl && <ImportRss url={rssUrl} />}
      {htmlUrl && <ImportUrl url={htmlUrl} />}
    </div>
  );
};

export default compose(
  connectProps({
    theme: (state) => state.theme,
    html: (state) => state.app.html,
    dragging: (state) => state.app.dragging,
  }),
)(Editor);
